document.addEventListener('turbo:load', () => {
  initModal();
});

function initModal() {
  const modal = document.getElementById('custom-confirm-modal');
  if (!modal) return;

  const messageEl = document.getElementById('custom-confirm-message');
  const btnCancel = modal.querySelector('.js-modal-cancel');
  const btnConfirm = modal.querySelector('.js-modal-confirm');

  let pendingForm: HTMLFormElement | null = null;
  let pendingUrl: string | null = null;

  document.querySelectorAll('.js-require-confirm').forEach(element => {
    element.addEventListener('click', function(this: HTMLElement, event) {
      event.preventDefault();

      pendingForm = null;
      pendingUrl = null;

      if (this.tagName.toLowerCase() === 'a') {
        pendingUrl = (this as HTMLAnchorElement).href;
      } else {
        pendingForm = this.closest('form');
      }

      const customMessage = this.getAttribute('data-confirm-message');
      if (messageEl) {
        if (customMessage) {
          messageEl.textContent = customMessage;
        } else {
          messageEl.textContent = 'Sind Sie sicher, dass Sie diese Aktion ausführen möchten?';
        }
      }

      modal.classList.add('is-active');
    });
  });

  btnCancel?.addEventListener('click', () => {
    modal.classList.remove('is-active');
    pendingForm = null;
    pendingUrl = null;
  });

  btnConfirm?.addEventListener('click', () => {
    if (pendingUrl) {
      window.location.href = pendingUrl;
    } else if (pendingForm) {
      pendingForm.submit();
    }

    modal.classList.remove('is-active');
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      modal.classList.remove('is-active');
      pendingForm = null;
      pendingUrl = null;
    }
  });
}